import React from 'react'
import { styled } from '@linaria/react'
import Mail from '../svgr/Mail'
import ArrowUpRight from '../svgr/ArrowUpRight'
import Twitter from '../svgr/Twitter'
import Telegram from '../svgr/Telegram'
import { FormattedMessage, useIntl } from 'react-intl'
import { Typography } from '../ui/Typography'
import { colors } from '../styles/colors'

export const SocialLinks = ({ className }: { className?: string }) => {
  const { locale } = useIntl()
  const telegramUrl =
    locale === 'ru' ? 'https://t.me/voteboxio_ru' : 'https://t.me/voteboxio'

  return (
    <SocialLinksContainer className={className}>
      {[
        {
          id: 'support',
          icon: <Mail />,
          href: 'mailto:support@votebox.io',
          label: (
            <FormattedMessage id="faq.support" defaultMessage="Поддержка" />
          ),
        },
        {
          id: 'x',
          icon: <Twitter />,
          href: 'https://x.com/voteboxio',
          label: <FormattedMessage id="faq.x" defaultMessage="X (Twitter)" />,
        },
        {
          id: 'telegram',
          icon: <Telegram />,
          href: telegramUrl,
          label: (
            <FormattedMessage
              id="faq.telegram"
              defaultMessage="Telegram канал"
            />
          ),
        },
        {
          id: 'docs',
          icon: <ArrowUpRight />,
          href: 'https://votebox.io/docs',
          label: (
            <FormattedMessage id="faq.docs" defaultMessage="Документация" />
          ),
        },
        {
          id: 'landing',
          icon: <ArrowUpRight />,
          href: 'https://votebox.io/',
          label: (
            <FormattedMessage
              id="faq.landing"
              defaultMessage="Главная страница"
            />
          ),
        },
        {
          id: 'legal',
          icon: <ArrowUpRight />,
          href: 'https://votebox.io/legal',
          label: (
            <FormattedMessage
              id="faq.legal"
              defaultMessage="Правовая информация"
            />
          ),
        },
      ].map(({ id, icon, href, label }) => (
        <LinkItem
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {icon}
          <Typography fontSize={14} color={colors.textPrimary}>
            {label}
          </Typography>
        </LinkItem>
      ))}
    </SocialLinksContainer>
  )
}

const SocialLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const LinkItem = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  padding: 8px 0;
  border-radius: 8px;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`
